import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { SubSink } from "subsink";
import { StringHelper } from "../../../utilities/contracts/string-helper";
import { DynamicControlDirective } from "../../dynamic-control-component.model";
import { FormService } from "../../form.service";
import { InputsService } from "../inputs.service";
import { TextBoxWithButton } from "./textboxwithbutton.model";

@Component({
  selector: "form-textbox-with-button",
  templateUrl: "./textbox-with-button.component.html",
  styleUrls: ["./textbox-with-button.component.scss"],
})
export class TextBoxWithButtonComponent extends DynamicControlDirective<TextBoxWithButton> implements OnInit, OnDestroy {
  private sink = new SubSink();
  @Output() onClick = new EventEmitter<any>();
  constructor(
    private readonly changeDetector: ChangeDetectorRef,
    private readonly formService: FormService,
    private readonly inputsService: InputsService
  ) {
    super();
  }

  ngOnInit() {
    this.sink.add(
      this.control.statusChanges.subscribe(() => this.formService.updateDom.next()),
      this.formService.updateDom.subscribe(() => this.changeDetector.markForCheck())
    );
  }

  ngOnDestroy() {
    this.sink.unsubscribe();
  }

  get classes(): string {
    return this.getClasses("textbox");
  }
  get hasTooltip(): boolean {
    return StringHelper.isAvailable(this.model.tooltip);
  }
  get hasLabelWhenInputIsDisabled(): boolean {
    return StringHelper.isAvailable(this.model.labelWhenInputIsDisabled);
  }
  get showLabelWhenInputIsDisabled(): boolean {
    return this.model.disabled && this.hasLabelWhenInputIsDisabled;
  }

  @HostListener("wheel", ["$event"])
  onWheel(event: Event) {
    event.preventDefault();
  }

  onButtonClick(value: any) {
    this.onClick.emit(value);
  }
  onChangeEvent(event): void {
    this.model.disabled = false;
  }

}
